import React, { useState } from 'react'
import Menu from "../Menu";

const ApiDoc = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [copiedId, setCopiedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const endpoints = [
    {
      id: 'posid-get',
      title: 'Send Message by POS ID',
      method: 'GET',
      endpoint: '/api/Send/Msg/PosId',
      description: 'Send a message to a specific POS using POS ID',
      category: 'POS ID',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Msg/PosId?apikey=abc&msg=%7B%7D&clientId=123&posId=14' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'posId', type: 'integer', required: true, location: 'query', description: 'Point of Sale ID' }
      ],
      response: 'text/plain'
    },
    {
      id: 'posid-post',
      title: 'Send Message by POS ID',
      method: 'POST',
      endpoint: '/api/Send/Msg/PosId',
      description: 'Send a message to a specific POS using POST method with optional queue support',
      category: 'POS ID',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Msg/PosId' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=abc&msg=%7B%7D&clientId=123&posId=14&allowQueue=true'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'posId', type: 'integer', required: true, location: 'body', description: 'Point of Sale ID' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing if true' }
      ],
      response: 'text/plain'
    },
    {
      id: 'merchant-get',
      title: 'Send Message by Merchant & POS Name',
      method: 'GET',
      endpoint: '/api/Send/Msg/MerchantName/PosName',
      description: 'Send a message to a specific POS using merchant and POS names',
      category: 'Merchant',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Msg/MerchantName/PosName?apikey=abc&msg=%7B%7D&clientId=123&merchantname=abc&posName=abc' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' }
      ],
      response: 'text/plain'
    },
    {
      id: 'merchant-post',
      title: 'Send Message by Merchant & POS Name',
      method: 'POST',
      endpoint: '/api/Send/Msg/MerchantName/PosName',
      description: 'Send a message using POST method with merchant and POS names',
      category: 'Merchant',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Msg/MerchantName/PosName?merchantname=abc&posName=abc&withactive=true' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=abc&msg=%7B%7D&clientId=123&allowQueue=true'`,
      parameters: [
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' },
        { name: 'withactive', type: 'boolean', required: false, location: 'query', description: 'Include only active POS' },
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-posid-get',
      title: 'Send Message by Subuser & POS ID',
      method: 'GET',
      endpoint: '/api/Send/Subuser/Msg/PosId',
      description: 'Send a message to a specific POS as a subuser using POS ID',
      category: 'Subuser',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/PosId?apikey=abc&subuserid=1&msg=%7B%7D&clientId=123&posname=abc' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'posname', type: 'string', required: true, location: 'query', description: 'Point of Sale name' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-posid-post',
      title: 'Send Message by Subuser & POS ID',
      method: 'POST',
      endpoint: '/api/Send/Subuser/Msg/PosId',
      description: 'Send a message as a subuser using POST method',
      category: 'Subuser',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/PosId?subuserid=1' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=abc&msg=%7B%7D&clientId=123&posname=abc&allowQueue=true'`,
      parameters: [
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'posname', type: 'string', required: true, location: 'body', description: 'Point of Sale name' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-merchant-get',
      title: 'Send Message by Subuser, Merchant & POS',
      method: 'GET',
      endpoint: '/api/Send/Subuser/Msg/MerchantName/PosName',
      description: 'Send a message as a subuser using merchant and POS names',
      category: 'Subuser',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/MerchantName/PosName?apikey=abc&subuserid=1&msg=%7B%7D&clientId=123&merchantname=abc&posName=abc' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-merchant-post',
      title: 'Send Message by Subuser, Merchant & POS',
      method: 'POST',
      endpoint: '/api/Send/Subuser/Msg/MerchantName/PosName',
      description: 'Send a message as a subuser using POST method with merchant and POS names',
      category: 'Subuser',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/MerchantName/PosName?subuserid=1&merchantname=abc&posName=abc' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=123&msg=%7B%7D&clientId=123&allowQueue=true'`,
      parameters: [
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' },
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing' }
      ],
      response: 'text/plain'
    },
    {
      id: 'upload-file',
      title: 'Upload File',
      method: 'POST',
      endpoint: '/api/Upload/File',
      description: 'Upload a file to a specified subfolder path',
      category: 'File Upload',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Upload/File' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: multipart/form-data' \\
  -F 'SubFolderPath=/abc' \\
  -F 'ApiKey=123' \\
  -F 'File=@Screenshot 2025-11-05 110528.png;type=image/png'`,
      parameters: [
        { name: 'SubFolderPath', type: 'string', required: true, location: 'form', description: 'Path to the subfolder where file will be uploaded (e.g., /abc)' },
        { name: 'ApiKey', type: 'string', required: true, location: 'form', description: 'API authentication key' },
        { name: 'File', type: 'file', required: true, location: 'form', description: 'File to be uploaded (supports images, documents, etc.)' }
      ],
      response: 'text/plain'
    },
    {
      id: 'upload-subuser-file',
      title: 'Upload File for Subuser',
      method: 'POST',
      endpoint: '/api/Upload/Subuser/File',
      description: 'Upload a file to a specified subfolder path for a subuser',
      category: 'File Upload',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Upload/Subuser/File' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: multipart/form-data' \\
  -F 'SubUserId=123' \\
  -F 'SubFolderPath=/abc' \\
  -F 'ApiKey=123' \\
  -F 'File=@Screenshot 2025-11-05 110528.png;type=image/png'`,
      parameters: [
        { name: 'SubUserId', type: 'integer', required: true, location: 'form', description: 'Subuser identifier' },
        { name: 'SubFolderPath', type: 'string', required: true, location: 'form', description: 'Path to the subfolder where file will be uploaded (e.g., /abc)' },
        { name: 'ApiKey', type: 'string', required: true, location: 'form', description: 'API authentication key' },
        { name: 'File', type: 'file', required: true, location: 'form', description: 'File to be uploaded (supports images, documents, etc.)' }
      ],
      response: 'text/plain'
    }
  ];

  const filteredEndpoints = endpoints.filter(endpoint =>
    endpoint.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    endpoint.endpoint.toLowerCase().includes(searchTerm.toLowerCase()) ||
    endpoint.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderOverviewTab = () => (
    <div className="api-overview">
      {/* Hero Section */}
      <div className="card mb-4" style={{ background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)', color: 'white', border: 'none' }}>
        <div className="card-body text-center p-5">
          <h1 className="display-4 mb-3">
            <i className="fas fa-code mr-3"></i>
            API Documentation
          </h1>
          <p className="lead">
            Powerful REST API for managing POS messaging across your platform
          </p>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="row mb-4">
        <div className="col-md-3 col-sm-6 mb-3">
          <div className="card">
            <div className="card-body text-center">
              <i className="fas fa-globe fa-2x text-primary mb-2"></i>
              <h6 className="card-title">Base URL</h6>
              <p className="card-text small">api.dqr-display-tms.bonrix.in</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className="card">
            <div className="card-body text-center">
              <i className="fas fa-plug fa-2x text-success mb-2"></i>
              <h6 className="card-title">Endpoints</h6>
              <p className="card-text h4">{endpoints.length}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className="card">
            <div className="card-body text-center">
              <i className="fas fa-lock fa-2x text-warning mb-2"></i>
              <h6 className="card-title">Authentication</h6>
              <p className="card-text">API Key</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className="card">
            <div className="card-body text-center">
              <i className="fas fa-file-alt fa-2x text-info mb-2"></i>
              <h6 className="card-title">Response Format</h6>
              <p className="card-text">text/plain</p>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="card mb-4">
        <div className="card-header">
          <h5 className="mb-0">
            <i className="fas fa-star mr-2"></i>
            Features
          </h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="fas fa-layer-group fa-2x text-primary mb-3"></i>
                  <h6 className="card-title">Multiple Identification Methods</h6>
                  <p className="card-text small">Target POS by ID, name, merchant name, or subuser with flexible routing options</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="fas fa-exchange-alt fa-2x text-success mb-3"></i>
                  <h6 className="card-title">Flexible Request Methods</h6>
                  <p className="card-text small">Full support for both GET and POST requests to suit your integration needs</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="fas fa-tasks fa-2x text-warning mb-3"></i>
                  <h6 className="card-title">Message Queuing</h6>
                  <p className="card-text small">Optional message queuing support for reliable asynchronous processing</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="fas fa-users fa-2x text-info mb-3"></i>
                  <h6 className="card-title">Subuser Access</h6>
                  <p className="card-text small">Dedicated endpoints for subuser message sending with granular control</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Getting Started */}
      <div className="card mb-4">
        <div className="card-header">
          <h5 className="mb-0">
            <i className="fas fa-rocket mr-2"></i>
            Getting Started
          </h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="card border-primary">
                <div className="card-body text-center">
                  <div className="badge badge-primary badge-pill mb-2" style={{ fontSize: '1.5rem', width: '40px', height: '40px', lineHeight: '40px' }}>1</div>
                  <h6 className="card-title">Get Your API Key</h6>
                  <p className="card-text small">Obtain your API key from the dashboard to authenticate your requests</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card border-primary">
                <div className="card-body text-center">
                  <div className="badge badge-primary badge-pill mb-2" style={{ fontSize: '1.5rem', width: '40px', height: '40px', lineHeight: '40px' }}>2</div>
                  <h6 className="card-title">Choose Your Endpoint</h6>
                  <p className="card-text small">Select the endpoint that matches your integration requirements</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card border-primary">
                <div className="card-body text-center">
                  <div className="badge badge-primary badge-pill mb-2" style={{ fontSize: '1.5rem', width: '40px', height: '40px', lineHeight: '40px' }}>3</div>
                  <h6 className="card-title">Make Your First Request</h6>
                  <p className="card-text small">Use the example curl commands to test and integrate quickly</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Common Parameters */}
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">
            <i className="fas fa-cog mr-2"></i>
            Common Parameters
          </h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card border-secondary">
                <div className="card-body">
                  <code className="text-primary">apikey</code>
                  <div className="mt-2">
                    <span className="badge badge-secondary">string</span>
                    <span className="badge badge-danger ml-1">Required</span>
                  </div>
                  <p className="card-text small mt-2">API authentication key for secure access</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card border-secondary">
                <div className="card-body">
                  <code className="text-primary">msg</code>
                  <div className="mt-2">
                    <span className="badge badge-secondary">json</span>
                    <span className="badge badge-danger ml-1">Required</span>
                  </div>
                  <p className="card-text small mt-2">Message payload (URL encoded in GET requests)</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card border-secondary">
                <div className="card-body">
                  <code className="text-primary">clientId</code>
                  <div className="mt-2">
                    <span className="badge badge-secondary">integer</span>
                    <span className="badge badge-danger ml-1">Required</span>
                  </div>
                  <p className="card-text small mt-2">Unique client identifier</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="card border-secondary">
                <div className="card-body">
                  <code className="text-primary">allowQueue</code>
                  <div className="mt-2">
                    <span className="badge badge-secondary">boolean</span>
                    <span className="badge badge-secondary ml-1">Optional</span>
                  </div>
                  <p className="card-text small mt-2">Enable message queuing if true</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEndpointTab = (endpointIndex) => {
    const endpoint = endpoints[endpointIndex];
    return (
      <div className="endpoint-detail">
        {/* Endpoint Header */}
        <div className="card mb-4">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className={`badge ${endpoint.method === 'GET' ? 'badge-info' : 'badge-success'} mr-2`}>
                  {endpoint.method}
                </span>
                <h5 className="mb-0 d-inline">{endpoint.title}</h5>
              </div>
              <span className="badge badge-secondary">{endpoint.category}</span>
            </div>
          </div>
          <div className="card-body">
            <p className="card-text">{endpoint.description}</p>
            <div className="alert alert-light">
              <code>{endpoint.endpoint}</code>
            </div>
          </div>
        </div>

        {/* Request Example */}
        <div className="card mb-4">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">
                <i className="fas fa-terminal mr-2"></i>
                Request Example
              </h6>
              <button 
                className={`btn btn-sm ${copiedId === endpoint.id ? 'btn-success' : 'btn-outline-primary'}`}
                onClick={() => copyToClipboard(endpoint.curl, endpoint.id)}
              >
                <i className={`fas ${copiedId === endpoint.id ? 'fa-check' : 'fa-copy'} mr-1`}></i>
                {copiedId === endpoint.id ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
          <div className="card-body">
            <pre className="mb-0" style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', fontSize: '12px', overflowX: 'auto' }}>
              {endpoint.curl}
            </pre>
          </div>
        </div>

        {/* Parameters */}
        <div className="card mb-4">
          <div className="card-header">
            <h6 className="mb-0">
              <i className="fas fa-sliders-h mr-2"></i>
              Parameters
            </h6>
          </div>
          <div className="card-body">
            {endpoint.parameters.map((param, idx) => (
              <div key={idx} className="card mb-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <code className="text-primary">{param.name}</code>
                    <div>
                      <span className={`badge ${param.location === 'query' ? 'badge-info' : param.location === 'body' ? 'badge-warning' : 'badge-secondary'} mr-1`}>
                        {param.location}
                      </span>
                      <span className={`badge ${param.required ? 'badge-danger' : 'badge-secondary'} mr-1`}>
                        {param.required ? 'Required' : 'Optional'}
                      </span>
                      <span className="badge badge-secondary">{param.type}</span>
                    </div>
                  </div>
                  <p className="card-text small mb-0">{param.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Response */}
        <div className="card">
          <div className="card-header">
            <h6 className="mb-0">
              <i className="fas fa-reply mr-2"></i>
              Response
            </h6>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <strong>Content-Type:</strong>
                <code className="ml-2">{endpoint.response}</code>
              </div>
              <div className="col-md-6">
                <strong>Status:</strong>
                <code className="ml-2">200 OK</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          {/* Header */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">API Documentation</h1>
              </div>
            </div>
          </section>

          {/* Navigation Tabs */}
          <section className="content">
            <div className="container-fluid">
              <div className="card mb-4">
                <div className="card-body p-0">
                  <ul className="nav nav-tabs" style={{ border: 'none', background: '#f8f9fa' }}>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === 'overview' ? 'active' : ''}`}
                        onClick={() => setActiveTab('overview')}
                        style={{ border: 'none', borderRadius: '0' }}
                      >
                        <i className="fas fa-home mr-2"></i>
                        Overview
                      </button>
                    </li>
                    {endpoints.map((endpoint) => (
                      <li className="nav-item" key={endpoint.id}>
                        <button
                          className={`nav-link ${activeTab === endpoint.id ? 'active' : ''}`}
                          onClick={() => setActiveTab(endpoint.id)}
                          style={{ border: 'none', borderRadius: '0' }}
                        >
                          <span className={`badge ${endpoint.method === 'GET' ? 'badge-info' : 'badge-success'} mr-2`}>
                            {endpoint.method}
                          </span>
                          {endpoint.title}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Content */}
              <div className="card">
                <div className="card-body">
                  {activeTab === 'overview' && renderOverviewTab()}
                  {endpoints.map((endpoint, idx) => (
                    activeTab === endpoint.id && (
                      <div key={endpoint.id}>
                        {renderEndpointTab(idx)}
                      </div>
                    )
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ApiDoc;
